export default "__VITE_ASSET__b1c7db7a__"